import scrollToElement from "./ScrollElement";

var $globalHeader = $(".global-header");

$(function () {
	let headerHeight = $globalHeader.outerHeight();
	$("body").css({
		"--header-height": headerHeight + "px",
	});
	window.headerHeight = headerHeight;

	let headerPositionCss = $globalHeader.css("position");

	if (headerPositionCss === "relative") {
		$globalHeader.sticky({
			top: 0,
			zIndex: 100,
		});
	}

	$(window).on("scroll", function () {
		var scrollTop = window.pageYOffset || $(document).scrollTop();
		$globalHeader.toggleClass("scrolling", scrollTop > 0);
	});

	$globalHeader.on("sticky-end", function () {
		$("#sticky-wrapper").css({
			height: headerHeight,
		});
	});

	const menuMapping = new MappingListener({
		selector: ".menu-wrapper",
		mobileWrapper: ".menu-mobile-body",
		mobileMethod: "appendTo",
		desktopWrapper: ".header-bottom-right",
		desktopMethod: "prependTo",
		breakpoint: 1025,
	}).watch();

	const topMenuMapping = new MappingListener({
		selector: ".top-menu",
		mobileWrapper: ".menu-mobile-body",
		mobileMethod: "appendTo",
		desktopWrapper: ".header-top-right",
		desktopMethod: "prependTo",
		breakpoint: 1025,
	}).watch();

	$(".close-menu-mobile, .menu-mobile-backdrop").on("click", function () {
		$(".menu-mobile").removeClass("show");
		$("body").removeClass("overflow-hidden");
		$(".menu-mobile-backdrop").fadeOut();
	});

	$(".menu-toggle").on("click", function () {
		$(".menu-mobile").addClass("show");
		$("body").addClass("overflow-hidden");
		$(".menu-mobile-backdrop").fadeIn();
	});

	if ($(window).width() < 1024.98) {
		$(".menu-item-has-children").each(function () {
			$(this)
				.find("> a")
				.after('<em class="far fa-angle-down  toggle-sub-menu"></em>');
		});
		$(".toggle-sub-menu").on("click", function () {
			$(this).parent().find(".sub-menu").slideToggle();
		});
	}

	var spy = new Gumshoe(".scroll-nav-list a", {
		offset: function () {
			return (
				headerHeight +
				$(".scroll-nav-list").outerHeight() +
				parseFloat($("section[id*='about-']").css("paddingTop"))
			);
		},
		events: true,
	});

	$(".anchor-link").on("click", function (e) {
		e.preventDefault();
		let href = $(this).attr("href");
		scrollToElement(href, 1000, headerHeight);
	});
});
